import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { AppearanceProvider } from "@/components/layout/AppearanceProvider";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { RouteProgress } from "@/components/shared/route-progress";
import { Toaster } from "@/components/ui/sonner";
import { DensityProvider } from "@/lib/density";
import { queryClient } from "@/lib/query";

export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppearanceProvider>
          <DensityProvider>
            <RouteProgress />
            <ErrorBoundary resetKey={pathname}>
              <Outlet />
            </ErrorBoundary>
            <Toaster />
          </DensityProvider>
        </AppearanceProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
